// extracted by mini-css-extract-plugin
export default {"manageRegions":"ManageRegion_manageRegions__qkskC"};